import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { registerVisitor } from '../../services/visitorService';
import { VISIT_TYPE_CONFIG } from '../../config/visitTypeFields';
import { QRCodeSVG } from 'qrcode.react';
import '../../styles/AdminVisitorRegistration.css';

export default function AdminVisitorRegistration() {
  const navigate = useNavigate();
  const [successData, setSuccessData] = useState(null);
  const [error, setError] = useState('');
  const { register, handleSubmit, watch, formState: { errors, isSubmitting } } = useForm();

  const selectedType = watch('visitType');
  const typeConfig = VISIT_TYPE_CONFIG[selectedType];

  const onSubmit = async (data) => {
    setError('');
    try {
      const res = await registerVisitor(data);
      if (res.success) {
        setSuccessData(res.data);
      }
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Erreur lors de l\'enregistrement');
    }
  };

  if (successData) {
    return (
      <div className="admin-visitor-reg">
        <div className="success-step">
          <div className="success-header">
            <span className="success-icon">✓</span>
            <h2>Visiteur enregistré avec succès</h2>
            <p>Le pass QR a été généré.</p>
          </div>
          
          <div className="qr-preview">
            <QRCodeSVG value={successData.qrPayload} size={200} />
            <div className="visitor-summary">
              <strong>{successData.visitorName}</strong>
              <span>{successData.visitType}</span>
            </div>
          </div>

          <div className="success-actions">
            <button className="btn btn-primary" onClick={() => setSuccessData(null)}>
              Inscrire un autre visiteur
            </button>
            <button className="btn btn-secondary" onClick={() => navigate('/admin/members')}>
              Retour à la liste
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-visitor-reg">
      <div className="form-card">
        <div className="form-header">
          <h1>Nouveau Visiteur</h1>
          <p>Enregistrement administratif direct.</p>
        </div>

        {error && <div className="error-banner">{error}</div>}

        <form onSubmit={handleSubmit(onSubmit)} className="admin-reg-form">
          <div className="form-section">
            <h3>Informations personnelles</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Nom Complet *</label>
                <input {...register('fullName', { required: 'Le nom est requis' })} placeholder="Jean Dupont" />
                {errors.fullName && <span className="field-error">{errors.fullName.message}</span>}
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input type="email" {...register('email', { required: 'L\'email est requis' })} placeholder="jean@email.com" />
                {errors.email && <span className="field-error">{errors.email.message}</span>}
              </div>

              <div className="form-group">
                <label>Téléphone *</label>
                <input type="tel" {...register('phone', { required: 'Le téléphone est requis' })} placeholder="+216 XX XXX XXX" />
                {errors.phone && <span className="field-error">{errors.phone.message}</span>}
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>Détails de la visite</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Type de visite *</label>
                <select {...register('visitType', { required: 'Type requis' })}>
                  <option value="">Sélectionner—</option>
                  {Object.entries(VISIT_TYPE_CONFIG).map(([key, config]) => (
                    <option key={key} value={key}>{config.label}</option>
                  ))}
                </select>
                {errors.visitType && <span className="field-error">{errors.visitType.message}</span>}
              </div>

              {typeConfig?.fields?.includes('hostCompany') && (
                <div className="form-group">
                  <label>Entreprise hôte</label>
                  <input {...register('hostCompany', { required: 'Obligatoire pour ce type' })} />
                </div>
              )}

              {typeConfig?.fields?.includes('hostContactName') && (
                <div className="form-group">
                  <label>Personne à rencontrer</label>
                  <input {...register('hostContactName', { required: 'Obligatoire pour ce type' })} />
                </div>
              )}

              {typeConfig?.fields?.includes('supplierCompany') && (
                <div className="form-group">
                  <label>Société fournisseur</label>
                  <input {...register('supplierCompany', { required: 'Obligatoire for fournisseurs' })} />
                </div>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/members')}>
              Annuler
            </button>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Enregistrement...' : 'Générer le Pass'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
